import { PlatformTourProvider } from '@/contexts/PlatformTourContext';
import { Outlet } from 'react-router-dom';
import { BottomTabBar } from './BottomTabBar';
import { Sidebar } from './Sidebar';
import { usePageScroll } from '@/hooks/usePageScroll';

export function Layout() {
  const scrollRef = usePageScroll();
  return (
    <PlatformTourProvider>
      <div className="flex h-dvh bg-background">
        <Sidebar className="hidden md:flex" />
        <div className="flex-1 flex flex-col isolate min-w-0 pb-[calc(4rem+1px+env(safe-area-inset-bottom))] md:pb-0">
          <main
            ref={scrollRef}
            className="flex-1 min-h-0 overflow-auto scrollbar-thin min-w-0"
          >
            <div className="flex h-full min-h-0 w-full max-w-full flex-col p-4 md:p-6 overflow-x-hidden">
              <Outlet />
            </div>
          </main>
        </div>
        <BottomTabBar />
      </div>
    </PlatformTourProvider>
  );
}
